import {Image, Box, Center} from 'platform/foundation';
import styled from 'styled-components';

interface ComponentProps {
  alt?: string;
  image?: string;
}

export function CebiaWidgetLogo({alt, image}: ComponentProps) {
  return (
    <ImageBackground>
      <Center width="100%" height="100%">
        <Box width="66%" height="66%">
          <Image
            src={image ?? '../../../../assets/images/cebia_logo.svg'}
            alt={alt}
            width="100%"
            height="100%"
            fit="contain"
          />
        </Box>
      </Center>
    </ImageBackground>
  );
}

// Specific color – Cebia logo background color
// eslint-disable-next-line eag/no-css-property
const ImageBackground = styled.div`
  background: #01215a;
  width: 100%;
  height: 100%;
`;
